export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["CoronaSavingsLimitMessaging"] = "FF_corona-virus-transaction-fee-copy";
    FeatureFlag["NewCustomerLimitEnabled"] = "FF_new-customer-limit-outbound-transfer";
    FeatureFlag["SuppressSavingsLimitMessaging"] = "FF_suppress-six-transactions-limit-copy";
})(FeatureFlag || (FeatureFlag = {}));
//# sourceMappingURL=FeatureFlag.js.map